/**
 * headerコンポーネント
 */

/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { memo } from "react";

const small = require("assets/img/header/corporate-logo-1.png");
const medium = require("assets/img/header/corporate-logo-1@2x.png");
const large = require("assets/img/header/corporate-logo-1@3x.png");

const header = memo(() => {
  return (
    <div css={headerWrap}>
      <img
        css={headerWrapImg}
        src={small}
        srcSet={`${small} 1x, ${medium} 2x, ${large} 3x`}
        alt="東京ガスロゴ"
      />
      {process.env.REACT_APP_SERVER_ENV === "stg" && (
        <>
          <p css={[envBadge, bgBlue]}>検証環境</p>
        </>
      )}
      {process.env.REACT_APP_SERVER_ENV === "dev" && (
        <>
          <p css={[envBadge, bgRed]}>開発環境</p>
        </>
      )}
    </div>
  );
});

const headerWrap = css`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  margin: auto;
  width: 100%;
  height: var(--mtg-header-height);
  padding: 16px 24px;
  background-color: var(--mtg-white);
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
`;

const headerWrapImg = css`
  width: 168px;
  height: 30px;
`;

const bgRed = css`
  background-color: var(--mtg-live-red);
`;

const bgBlue = css`
  background-color: var(--mtg-urbanblue);
`;

const envBadge = css`
  position: absolute;
  top: 12px;
  left: 216px;
  height: 40px;
  text-align: center;
  color: var(--mtg-white);
  padding: 0 var(--mtg-padding-width);
  margin: auto;
  font-size: var(--mtg-h1-s);
  font-weight: var(--mtg-h1-w);
  border-radius: 10px;
`;

export default header;
